import type {
  Property,
  PropertyRule,
  PropertyType,
  PropertyTypeFeature,
  PropertyTypeRule,
} from "../types";

/** API may return rule.feature as "permanent_parking" while section key is "permanentparking". */
const SECTION_TO_RULE_FEATURE: Record<string, string[]> = {
  permanentparking: ["permanentparking", "permanent_parking"],
};

/**
 * Merges property-type rules for a feature with property overrides (Features tab pattern).
 * Property override wins when present; otherwise the type template value is kept.
 */
export function mergePropertyFeatureRules(
  featureKey: PropertyTypeFeature,
  typeRules: PropertyTypeRule[],
  propertyRules: PropertyRule[],
): PropertyTypeRule[] {
  const ruleFeatureKeys = SECTION_TO_RULE_FEATURE[featureKey] ?? [featureKey];
  return typeRules
    .filter((rule) => ruleFeatureKeys.includes(rule.feature as string))
    .map((rule) => {
      const propertyRule = propertyRules.find((pr) => pr.id === rule.rule_id);
      const value =
        propertyRule?.value !== undefined && propertyRule?.value !== null
          ? propertyRule.value
          : rule.value;
      return {...rule, value};
    });
}

export function findPropertyTypeForProperty(
  propertyTypes: PropertyType[],
  property: Property,
): PropertyType | undefined {
  const typeId = property.type?.id;
  if (typeId == null) return undefined;
  return propertyTypes.find((t) => Number(t.property_type_id) === Number(typeId));
}
